export default __webpack_public_path__ + "static/media/saving.icon.04c77982.svg";